export default __webpack_public_path__ + "static/media/akar-icons_arrow-down (1).73810b86.svg";